import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faLink, faArrowUp } from "@fortawesome/free-solid-svg-icons";

export const ArrowUp = () => <FontAwesomeIcon icon={faAngleUp} />
export const ArrowDown = () => <FontAwesomeIcon icon={faAngleDown} />
export const LinkIcon = () => <FontAwesomeIcon icon={faLink} />
export const ArrowToTop = () => <FontAwesomeIcon icon={faArrowUp} />